import { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  Button,
  AppBar,
  Toolbar,
  CircularProgress,
  Pagination,
  Stack,
  Autocomplete,
  Grid,
  TextField,
} from "@mui/material";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";
import Colors from "../../assets/styles";
import AuthServices from "../../apis/AuthServices";
import moment from "moment";
import SimpleDialog from "../../components/Modal/index";
import { Controller, useForm } from "react-hook-form";
import { SuccessToaster } from "../../components/toaster";
import { useNavigate } from "react-router-dom";

const statusOptions = ["End Journey", "Engine Failure", "Interchange"];

export default function LiveTrains() {
  const [liveTrains, setLiveTrains] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [isLoading, setIsLoading] = useState(false);
  const [trains, setTrains] = useState([]);
  const [stations, setStations] = useState([]);
  const [locomotives, setLocomotives] = useState([]);
  const [openInterChange, setOpenInterChange] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [selectedTrain, setSelectedTrain] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
const navigate = useNavigate()
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      trainName: "",
      allocatedDate: moment().format("YYYY-MM-DD"),
      stationName: "",
      locomotive: "",
    },
  });
  const handlePageChange = (event, newPage) => {
    setPage(newPage - 1);
  };
  const getLiveTrain = async () => {
    setIsLoading(true);
    try {
      const result = await AuthServices.getLiveTrain();
      if (result.IsSuccess === true) {
        const updatedTrains = result.Response.map((train) => ({
          ...train,
          status: "End Journey",
        }));
        setLiveTrains(updatedTrains);
        setIsLoading(false);
      }
    } catch (error) {
      // console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const getTrainById = async (train) => {
    try {
      const result = await AuthServices.getTrainsById(train?.TrainId);
      // console.log(result);
      if (result.IsSuccess == true) {
        setStations(result.Response);
      }
    } catch (error) {
      // console.log(error);
    }
  };
  const getLocomotive = async () => {
    try {
      const result = await AuthServices.getLocomotive();
      // console.log(result);
      if (result.IsSuccess == true) {
        setLocomotives(result.Response);
      }
    } catch (error) {
      // console.log(error);
    }
  };
  useEffect(() => {
    getLiveTrain();
  }, []);

  const handleStatusChange = (id, newStatus) => {
    setLiveTrains((prevTrains) =>
      prevTrains.map((train) =>
        train.LocomotiveNumber === id ? { ...train, status: newStatus } : train
      )
    );
  };

  const handleSubmit2 = async (train) => {
    // for endjourney
    setSelectedTrain(train);

    const obj = {
      trainId: train.TrainId,
      trainNumber: train.TrainNumber,
      locomotiveNumber: train.LocomotiveNumber,
      trainRideId: train.TrainRideId,
      rideCompleteDate: train.AllocatedDate,
      rideStatusId: 1,
    };

    if (train.status === "Interchange" || train.status === "Engine Failure") {
      setOpenInterChange(true);
      setSelectedTrain(train);
      getTrainById(train);
      getLocomotive();
    } else if (train.status === "End Journey") {
      // setSelectedTrain(train);
      setConfirmDialog(true);
      // try {
      //   const result = await AuthServices.updateLocomotive(
      //     obj.trainId,
      //     obj.trainNumber,
      //     obj.locomotiveNumber,
      //     obj.trainRideId,
      //     obj.rideCompleteDate,
      //     obj.rideStatusId
      //   );
      //   if (result.IsSuccess == true) {
      //     SuccessToaster("Journey Ended Successfully");
      //     getLiveTrain();
      //   }
      // } catch (error) {
      //   console.log(error);
      // }
    }
  };
  // console.log(selectedTrain);
  
  const EndJourney = async (formData) => {
    const obj = {
      trainId: selectedTrain.TrainId,
      trainNumber: selectedTrain.TrainNumber,
      locomotiveNumber: selectedTrain.LocomotiveNumber,
      trainRideId: selectedTrain.TrainRideId,
      rideCompleteDate: selectedTrain.AllocatedDate,
      rideStatusId: selectedTrain.status == "End Journey" ?1 :3,
    };
    try {
      const result = await AuthServices.Complete(
        obj.trainId,
        obj.trainNumber,
        obj.locomotiveNumber,
        obj.trainRideId,
        obj.rideCompleteDate,
        obj.rideStatusId
      );
      if (result.IsSuccess == true) {
        SuccessToaster("Journey Ended Successfully");
        setConfirmDialog(false);
        navigate("/allocation-list")
        if(selectedTrain.status != "End Journey"){
          onSubmit(formData)
        }
        getLiveTrain();
      }
    } catch (error) {
      // console.log(error);
    }
  };
  const onSubmit = async (formData) => {
    setIsSubmitting(true)
    const obj = {
      StationId: formData.stationName,
      TrainId: selectedTrain.TrainId,
      LocomotiveNumber: formData.locomotive,
      Remarks: selectedTrain?.status == "Interchange"? "Interchange": "Engine Failure",
      RideStatusId: 3,
      AllocatedDate: selectedTrain.AllocatedDate,
    };
    // console.log(obj);
    try {
      const result = await AuthServices.allocateLocomotive(obj);
      if (result.IsSuccess == true) {
        setOpenInterChange(false);
        SuccessToaster("ReAllocated Successfully");
        reset();
        // EndJourney()
        
        getLiveTrain();
        navigate("/allocation-list")
      }
    } catch (error) {
      // console.log(error);
    }finally{
    setIsSubmitting(false)

    }
  };

  return (
    <>
      <Box sx={{ mb: 3 }}>
        <AppBar position="static" color="transparent" elevation={0}>
          <Toolbar
            sx={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <Box>
              <Typography
                variant="h5"
                component="h1"
                sx={{
                  color: Colors.primary,
                  fontWeight: 500,
                  letterSpacing: "1px",
                }}
              >
                LIVE TRAINS
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary">
                TRAIN / LIVE TRAINS
              </Typography>
            </Box>
          </Toolbar>
        </AppBar>
      </Box>
      <SimpleDialog
        open={confirmDialog}
        onClose={() => {
          setConfirmDialog(false);
        }}
      >
        <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
          Are you sure you want to End this journey?
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "space-around", gap: 2 }}>
          <Button
            sx={{ background: "grey", color: "white", px: 2.5 }}
            onClick={() => setConfirmDialog(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{ background: "rgb(0, 100, 0)" }}
            onClick={EndJourney}
          >
            Confirm
          </Button>
        </Box>
      </SimpleDialog>

      <SimpleDialog
        open={openInterChange}
        onClose={() => {
          setOpenInterChange(false);
          reset();
        }}
        maxWidth={"md"}
        title="Locomotive Allocation"
      >
        <Box component="form" onSubmit={handleSubmit(EndJourney)}>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              flexDirection: { xs: "column", md: "row" },
              mb: 3,
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
                Train Name
              </Typography>
              <TextField
                fullWidth
                value={selectedTrain.TrainName}
                disabled
                InputProps={{
                  readOnly: true,
                }}
              />
            </Box>

            <Box sx={{ width: "100%" }}>
              <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
                Station Name
              </Typography>
              <Controller
                name="stationName"
                control={control}
                rules={{ required: "Station Name is required" }}
                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    options={stations}
                    getOptionLabel={(option) => option?.StationName || ""}
                    isOptionEqualToValue={(option, value) =>
                      option?.StationDetailsId === value
                    }
                    value={
                      stations?.find(
                        (station) => station.StationDetailsId === field.value
                      ) || null
                    }
                    onChange={(_, value) =>
                      field.onChange(value?.StationDetailsId || "")
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        error={!!errors.stationName}
                        helperText={errors.stationName?.message}
                      />
                    )}
                  />
                )}
              />
            </Box>
            <Box sx={{ width: "100%" }}>
              <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
                Locomotive
              </Typography>
              <Controller
                name="locomotive"
                control={control}
                rules={{ required: "Locomotive is required" }}
                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    options={locomotives}
                    getOptionLabel={(option) => option?.LocomotiveNumber || ""}
                    isOptionEqualToValue={(option, value) =>
                      option?.LocomotiveNumber === value
                    }
                    value={
                      locomotives?.find(
                        (loco) => loco.LocomotiveNumber === field.value
                      ) || null
                    }
                    onChange={(_, value) =>
                      field.onChange(value?.LocomotiveNumber || "")
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        error={!!errors.locomotive}
                        helperText={errors.locomotive?.message}
                      />
                    )}
                  />
                )}
              />
            </Box>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              type="submit"
              variant="contained"
              disabled={isSubmitting} 
              sx={{
                bgcolor: "darkgreen",
                px:4,
                py:1,
                "&:hover": {
                  bgcolor: "green",
                },
              }}
            >
             {isSubmitting ? <CircularProgress size={20} sx={{color:"green" }}/> : "Allocate"}

            </Button>
          </Box>
        </Box>
      </SimpleDialog>
      <Container
        maxWidth="xl"
        sx={{
          mt: 2,
          boxShadow: "0px 8px 24px 0 #4545501A",
          py: 2,
          borderRadius: "12px",
          backgroundColor: Colors.white,
        }}
      >
        <TableContainer sx={{ height: "auto", overflowX: "auto" }}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: "rgb(19 62 2)" }}>
                <TableCell sx={{ color: "white", width: "5%" }}>#</TableCell>
                <TableCell sx={{ color: "white", width: "25%" }}>
                  Train
                </TableCell>
                <TableCell sx={{ color: "white", width: "20%" }}>
                  Allocated Date
                </TableCell>
                <TableCell sx={{ color: "white", width: "20%" }}>
                  Locomotive
                </TableCell>
                <TableCell sx={{ color: "white", width: "20%" }}>
                  Complete
                </TableCell>
                <TableCell sx={{ color: "white", width: "10%" }}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    <Box
                      sx={{ display: "flex", justifyContent: "center", py: 2 }}
                    >
                      <CircularProgress
                        size={24}
                        sx={{ color: "rgb(19 62 2)" }}
                      />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : (
                liveTrains
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((train, index) => (
                    <TableRow
                      key={train.id}
                      sx={{
                        "&:nth-of-type(odd)": { bgcolor: "#f5f5f5" },
                        "&:hover": { bgcolor: "#f0f0f0" },
                      }}
                    >
                      <TableCell>{index + 1 + page * rowsPerPage}</TableCell>
                      <TableCell>{train.TrainName}</TableCell>
                      <TableCell>
                        {moment(train.AllocatedDate).format("Do MMM YYYY")}
                      </TableCell>
                      <TableCell>{train.LocomotiveNumber}</TableCell>
                      <TableCell>
                        <Select
                          size="small"
                          value={train.status}
                          onChange={(e) =>
                            handleStatusChange(
                              train.LocomotiveNumber,
                              e.target.value
                            )
                          }
                          fullWidth
                        >
                          {statusOptions.map((option) => (
                            <MenuItem key={option} value={option}>
                              {option}
                            </MenuItem>
                          ))}
                        </Select>
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          onClick={() => handleSubmit2(train)}
                          sx={{
                            bgcolor: "rgb(19 62 2)",
                            "&:hover": {
                              bgcolor: "green",
                            },
                          }}
                        >
                          Submit
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          sx={{ mt: 2 }}
        >
          <Pagination
            count={Math.ceil(liveTrains.length / rowsPerPage)}
            page={page + 1}
            onChange={handlePageChange}
            variant="outlined"
            shape="rounded"
            color="success"
            sx={{
              "& .MuiPaginationItem-root": {
                borderColor: "rgb(19, 62, 2)",
                color: "rgb(19, 62, 2)",
              },
              "& .MuiPaginationItem-page.Mui-selected": {
                bgcolor: "rgb(19, 62, 2)",
                color: "white",
              },
            }}
          />
        </Stack>
      </Container>
    </>
  );
}
